import { Controller, Control, FieldErrors } from 'react-hook-form';
import { LoanFormData } from '@/schemas/loanSchema';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { DatePicker } from '@/components/ui/date-picker';

interface Props {
  control: Control<LoanFormData>;
  errors: FieldErrors<LoanFormData>;
}

export const StepUpTermsSection = ({ control }: Props) => (
  <div className="p-8 mb-8">
    <h3 className="section-title">Step-Up Terms & Provisions</h3>
    <div className="grid-2">
      <div>
        <Label
          className="form-label loanform-label"
          htmlFor="step_up.step_up_date"
        >
          Step-Up Date
        </Label>
        <Controller
          name="step_up.step_up_date"
          control={control}
          render={({ field }) => (
            <DatePicker
              value={field.value ? (typeof field.value === 'string' ? field.value : new Date(field.value).toISOString().split('T')[0]) : ''}
              onChange={(val) => field.onChange(val ? new Date(val) : undefined)}
              data-test-id="step-up-date-input"
            />
          )}
        />
      </div>
      <div>
        <Label
          className="form-label"
          htmlFor="step_up.step_up_incremental_rate"
        >
          Step-Up Incremental Rate
        </Label>
        <Controller
          name="step_up.step_up_incremental_rate"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              type="number"
              id="step_up.step_up_incremental_rate"
              className="input-full"
              value={field.value ?? ''}
            />
          )}
        />
      </div>
      <div>
        <Label className="form-label" htmlFor="step_up.step_up_coupons">
          Step-Up Coupons
        </Label>
        <Controller
          name="step_up.step_up_coupons"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              id="step_up.step_up_coupons"
              className="input-full"
              value={field.value ?? ''}
            />
          )}
        />
      </div>
      <div>
        <Label
          className="form-label"
          htmlFor="step_up.step_up_margin_interest_rate_floor"
        >
          Step-Up Margin Interest Rate Floor
        </Label>
        <Controller
          name="step_up.step_up_margin_interest_rate_floor"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              id="step_up.step_up_margin_interest_rate_floor"
              className="input-full"
              value={field.value ?? ''}
            />
          )}
        />
      </div>
    </div>
  </div>
);
